import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/domain/item-page-data'

import { ItemPageLegalDpoFootnotePluginModel } from './types'

export const getItemPageLegalDpoFootnotePluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageLegalDpoFootnotePluginModel => ({
  business: itemDto.user.business,
  businessAccount: itemDto.user.business_account,
})

export const getServerItemPageLegalDpoFootnotePluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageLegalDpoFootnotePluginModel => ({
  business: sidebarDto.business,
  businessAccount: sidebarDto.business_account,
})
